import dayjs from "dayjs"
import PortalAssignmentTypes from "../../../types/portalRoleTypes/PortalAssignmentTypes"

const PortalAssignmentBoilerPlate: PortalAssignmentTypes = {
    PortalRoleAssignmentId: null,
    PortalRoleName: null,
    Target: null,
    CreatedDate: dayjs().format(),
    CreatedBy: null,
    ModifyDate: null,
    ModifiedBy: null,
    DeletedDate: null,
    DeletedBy: null,
    DisabledDate: null,
    DisabledBy: null,
    Description: null
}

export default PortalAssignmentBoilerPlate